let baseURL = "https://preprod.odesk.geezdata.com";
let wsURL = "wss://preprod.odesk.geezdata.com";

export { baseURL, wsURL };
